import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {environment} from '../../../environments/environment.local';
import {Adb2cBody} from '../../models/adb2c/Adb2cBody';
import {Adb2cResponse, Adb2csResponse} from '../../models/adb2c/Adb2cResponse';
import {Observable} from 'rxjs';
import {Adb2cBodyPatch} from '../../models/adb2c/Adb2cBodyPatch';
import {Adb2cDeleteResponse} from '../../models/adb2c/Adb2cDeleteResponse';

@Injectable({
  providedIn: 'root'
})
export class Adb2cService {
  private apiUrl = `${environment.apiUrl}/adb2c`;

  constructor(private http: HttpClient) {
  }

  getAdb2c(params?: any): Observable<Adb2csResponse> {
    return this.http.get<Adb2csResponse>(this.apiUrl, {params});
  }

  getAdb2cById(id: string): Observable<Adb2cResponse> {
    return this.http.get<Adb2cResponse>(`${this.apiUrl}/${id}`);
  }

  postAdb2c(adb2cBody: Adb2cBody): Observable<Adb2cResponse> {
    return this.http.post<Adb2cResponse>(this.apiUrl, adb2cBody);
  }

  updateAdb2c(id: string, adb2cBodyPatch: Adb2cBodyPatch): Observable<Adb2cResponse> {
    return this.http.patch<Adb2cResponse>(`${this.apiUrl}/${id}`, adb2cBodyPatch);
  }

  deleteAdb2c(id: string): Observable<Adb2cDeleteResponse> {
    return this.http.delete<Adb2cDeleteResponse>(`${this.apiUrl}/${id}`);
  }
}
